import { CardAction, CardDefinition, Order, TemplateEnum } from '@barthauer/abc/cards-view';
import { CompareHelper } from '@barthauer/abc/core';
import { BCEDocument, BCEElement, BCEFolder, BCEGroup, BCEObject, BCETemplate } from '../models/bce.model';
import { DataService } from '../services/data.service';
import { ResourceSet } from '@barthauer/abc/core/resources';

export class GroupCard implements CardDefinition {
  Icon: string;
  DisplayText: string;
  SecondaryDisplayText: string;
  Picture: string;
  Description: string;
  PrimaryAction: CardAction;
  SecondaryAction: CardAction;
  ThirdAction: CardAction;
  FourthAction: CardAction;
  OtherActions: CardAction[];
  CardDefinitions: CardDefinition[] = [];
  Template: TemplateEnum;
  Order: Order;
  DataObject: BCEGroup;

  constructor(res: ResourceSet, data: BCEGroup, factory: (obj: BCEObject) => CardDefinition) {
    this.DisplayText = data.Designation;
    this.Description = data.Description;
    this.Template = TemplateEnum.Large;
    this.DataObject = new BCEGroup(data);
    data.Childs?.sort((a, b) => CompareHelper.compare(a.Designation, b.Designation))?.forEach((element) => {
      const card = factory(element);
      if (card) {
        this.CardDefinitions.push(card);
      }
    });
    this.SecondaryDisplayText = DataService.getDocumentCount(this) + ' ' + res.get('Documents');
  }

  IsVisible(search: string): boolean {
    return search ? false : true;
  }
}

export class FolderCard implements CardDefinition {
  Icon: string;
  DisplayText: string;
  SecondaryDisplayText: string;
  Description: string;
  Picture: string;
  PrimaryAction?: CardAction;
  SecondaryAction?: CardAction;
  ThirdAction?: CardAction;
  FourthAction?: CardAction;
  OtherActions: CardAction[];
  CardDefinitions: CardDefinition[] = [];
  Template: TemplateEnum;
  Order: Order;
  DataObject: BCEFolder;

  constructor(res: ResourceSet, data: BCEFolder, factory: (obj: BCEObject) => CardDefinition) {
    this.DisplayText = data.Designation;
    this.Description = data.Description;
    this.Template = TemplateEnum.Small;
    this.DataObject = new BCEFolder(data);
    data.Childs?.sort((a, b) => CompareHelper.compare(a.Designation, b.Designation))?.forEach((element) => {
      const card = factory(element);
      if (card) {
        this.CardDefinitions.push(card);
      }
    });
    this.SecondaryDisplayText = DataService.getDocumentCount(this) + ' ' + res.get('Documents');
  }
  IsVisible(search: string): boolean {
    return search ? false : true;
  }
}

export abstract class DocumentCardBase<T extends BCEElement> implements CardDefinition {
  Icon: string;
  DisplayText: string;
  Description: string;
  Picture: string;
  PrimaryAction: CardAction;
  SecondaryAction: CardAction;
  ThirdAction: CardAction;
  FourthAction: CardAction;
  OtherActions: CardAction[];
  Template: TemplateEnum;
  Order: Order;
  DataObject: T;
  constructor(data: T) {
    this.DisplayText = data.Designation;
    this.Description = data.Description;
    this.Template = TemplateEnum.Small;
    this.DataObject = data;
  }
  IsVisible(search: string): boolean {
    return search ? true : false;
  }
}

export class DocumentCard extends DocumentCardBase<BCEDocument> {
  constructor(data: BCEDocument) {
    super(data);
  }
}

export class TemplateCard extends DocumentCardBase<BCETemplate> {
  constructor(data: BCETemplate) {
    super(data);
  }
}
